import PropTypes from 'prop-types';
import {
    OBJECT_COMMON_FACILITY_SUMMARY,
    OBJECT_COMMON_FACILITY,
    OBJECT_COMMON_RATE,
    PROPTYPE_PRICE,
    PROPTYPE_REDEMPTION_INSTRUCTION,
} from './common';

export const PROPTYPE_MONTHLY_RESERVATION_TYPE = PropTypes.oneOf([
    '247',
    'daytime_only',
    'daytime_and_247_weekend',
    'nights_only',
    'nights_and_247_weekend',
    'storage',
    'valet',
]);

export const OBJECT_MONTHLY_RATE = {
    ...OBJECT_COMMON_RATE,
    contract: PropTypes.shape({
        cancellationRequirements: PropTypes.shape({
            noticeDays: PropTypes.number.isRequired,
            noticeRequired: PropTypes.bool.isRequired,
        }).isRequired,
        durationMonths: PropTypes.number.isRequired,
        required: PropTypes.bool.isRequired,
        terminationFee: PROPTYPE_PRICE,
    }).isRequired,
    inOutPrivileges: PropTypes.shape({
        allowed: PropTypes.bool.isRequired,
        description: PropTypes.string.isRequired,
        fee: PROPTYPE_PRICE.isRequired,
    }).isRequired,
    postPurchaseInstructions: PropTypes.string,
    redemptionInstructions: PropTypes.shape({
        longTerm: PropTypes.arrayOf(PROPTYPE_REDEMPTION_INSTRUCTION),
        shortTerm: PropTypes.arrayOf(PROPTYPE_REDEMPTION_INSTRUCTION),
    }),
    monthlyReservationType: PROPTYPE_MONTHLY_RESERVATION_TYPE.isRequired,
    startDateOptions: PropTypes.shape({
        restriction: PropTypes.oneOf(['1st_only', '1st_or_15th', 'none'])
            .isRequired,
        choices: PropTypes.arrayOf(
            PropTypes.shape({
                ends: PropTypes.string.isRequired,
                starts: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
};

export const OBJECT_MONTHLY_FACILITY_SUMMARY = {
    ...OBJECT_COMMON_FACILITY_SUMMARY,
    allMonthlyReservationTypes: PropTypes.arrayOf(
        PROPTYPE_MONTHLY_RESERVATION_TYPE
    ), // all reservation types across available rates, if applicable
    selectedRate: PropTypes.shape(OBJECT_MONTHLY_RATE),
};
export const PROPTYPE_MONTHLY_FACILITY_SUMMARY = PropTypes.shape(
    OBJECT_MONTHLY_FACILITY_SUMMARY
);

export const OBJECT_MONTHLY_FACILITY = {
    ...OBJECT_COMMON_FACILITY,
    highestPrice: PROPTYPE_PRICE,
    lowestPrice: PROPTYPE_PRICE,
    rates: PropTypes.arrayOf(PropTypes.shape(OBJECT_MONTHLY_RATE)),
    selectedRate: PropTypes.shape(OBJECT_MONTHLY_RATE),
};
